import React from "react";

const LeftIcon: React.FC = () => {
  return (
    <svg viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <path
          d="M18.8801332,6.3905389 L26.6002517,13.9332934 C26.8963618,14.2226006 27.027223,14.6172613 26.9914684,14.9996554 C27.0274518,15.3820481 26.8966209,15.7771463 26.6002517,16.0667066 L26.6002517,16.0667066 L18.8801332,23.6094611 C18.3435808,24.1336867 17.4866561,24.1336867 16.9501036,23.6094611 L16.9501036,23.6094611 L16.9284425,23.5878 C16.4196871,23.0670814 16.4293851,22.2325279 16.9501036,21.7237725 L16.9501036,21.7237725 L22.692,16.114 L4.33338322,16.1147603 C3.64029407,16.1147603 3.07071493,15.5859511 3.00610385,14.9097908 L3,14.7813771 C3,14.0449699 3.596976,13.4479939 4.33338322,13.4479939 L4.33338322,13.4479939 L22.243,13.447 L16.9501036,8.27622753 C16.4293851,7.76747211 16.4196871,6.93291858 16.9284425,6.41220004 L16.9501036,6.3905389 L16.9501036,6.3905389 C17.4866561,5.86631335 18.3435808,5.86631335 18.8801332,6.3905389 Z"
          transform="translate(15.000000, 15.000000) scale(-1, 1) translate(-15.000000, -15.000000) "
        ></path>
      </g>
    </svg>
  );
};

export default LeftIcon;
